export const phonePrefixesByCountry = {
  1: {
    code: 54,
    country: 'ar'
  },
  9: {
    code: 593,
    country: 'ec'
  },
  11: {
    code: 51,
    country: 'pe'
  },
  18: {
    code: 52,
    country: 'mx'
  },
  20: {
    code: 507,
    country: 'pa'
  },
  1007: {
    code: 56,
    country: 'cl'
  },
  30: {
    code: 61,
    country: 'au'
  },
  13: {
    code: 58,
    country: 've'
  },
  12: {
    code: 598,
    country: 'uy'
  },
  10: {
    code: 595,
    country: 'py'
  },
  15: {
    code: 503,
    country: 'sv'
  },
  16: {
    code: 502,
    country: 'gt'
  }
};
